var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "modal",
      staticClass: "extend__work-permit",
      attrs: {
        beforeCloseModal: _vm.beforeCloseModal,
        afterOpenModal: _vm.afterOpenModal,
        beforeOpenModal: _vm.beforeOpenModal,
        afterCloseModal: _vm.afterCloseModal,
      },
    },
    [
      _c("p", { staticClass: "extend-permit-hint" }, [
        _vm._v(_vm._s(_vm.extendHint)),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _vm.isOpen
          ? _c(
              "div",
              { staticClass: "generalInfo_timePicker" },
              [
                _c("DateTimeSelector", {
                  attrs: {
                    required: _vm.required,
                    date: _vm.value,
                    canPutTotop: false,
                    showClearBtn: _vm.showClearBtn,
                    setMinTime: _vm.setMinTime,
                    disabledDateTimes: _vm.disabledDateTimes,
                  },
                  on: { updateDate: _vm.dateSetter },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
        _c(
          "button",
          {
            staticClass: "btn btn--darkblue",
            attrs: { type: "button" },
            on: { click: _vm.cancel },
          },
          [_vm._v(_vm._s(_vm.$t("action.cancel")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--orange",
            attrs: { type: "button", disabled: _vm.buttonDisabled },
            on: { click: _vm.extend },
          },
          [_vm._v("\n      " + _vm._s(_vm.extendButton) + "\n    ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }